<template>
  <div>
    <v-card
      v-for="(item, i) in map.data ? map.data.slice(0, 1) : []"
      :key="i"
      elevation="0"
      height="40vh"
      style="pointer-events: none; position: sticky"
    >
      <l-map ref="myMap" :zoom="zoom" :center="[item.lat, item.long]">
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-marker :lat-lng="[item.lat, item.long]"></l-marker>
      </l-map>
    </v-card>
  </div>
</template>

<script>
import L from "leaflet";
import { Icon } from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

export default {
  props: {
    customersAbout: {},
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  data() {
    return {
      url: "https://tiles.balad.ir/tiles/rendered/{z}/{x}/{y}.jpg?token=divarLBPfynHRGPJPG22GY2iskJNPHSQ&style=raster_divar",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 15,
      center: [51.505, -0.159],
      markerLatLng: [51.504, -0.159],
      map: [],
      location: window.document.location.host.replace("www.", ""),
    };
  },
  created() {
    this.map = this.$props.customersAbout.data.addresses;
    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.$refs.myMap.mapObject.ANY_LEAFLET_MAP_METHOD();
    // });
  },
  methods: {
    doSomethingOnReady() {
      this.map = this.$refs.myMap.mapObject;
    },
    // async booths() {
    //   let response = await this.axios.get(
    //     "https://namya.ir/api/v1/businesses/booths/48"
    //   );
    //   // console.log(this.$route.params.name);
    //   this.map = response.data.data.addresses;
    //   this.customers = response.data;
    //   this.title = this.customers.data.name;
    //   this.keywords = this.customers.data.tags.map((tags) => `${tags.name}`);
    //   this.description = this.customers.data.aboutus;
    //   localStorage.setItem("ID", JSON.stringify(this.customers.data.id));
    //   this.tags = this.customers.data.tags;
    // },
  },
};
</script>
<style>
.leaflet-control-attribution.leaflet-control {
  visibility: hidden;
}
</style>
